<template>
  <div id="app-container" class="app-container-box">
    <div class="top-blue-bg"></div>
    <div class="user-content-box">
      <div class="my-header-box">
        <div class="user-box">
          <img class="user-head" :src="user_info.avatar" />
          <span class="user-name">{{ user_info.realname }}</span>
          <span class="user-school">{{ user_info.depart }}</span>
        </div>
        <div class="user-tab-box">
          <div
            class="user-tab-item"
            :class="{ select: typeSelect == 1 }"
            @click="medalTypeClick(1)"
          >
            <img
              v-if="typeSelect == 1"
              src="../../assets/icon_medal_select.png"
            />
            <img v-else src="../../assets/icon_medal_normal.png" />
            <span>个人成就</span>
          </div>
          <div
            class="user-tab-item"
            :class="{ select: typeSelect == 2 }"
            @click="medalTypeClick(2)"
          >
            <img
              v-if="typeSelect == 2"
              src="../../assets/icon_message_select.png"
            />
            <img v-else src="../../assets/icon_message_normal.png" />
            <span>我的消息</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content-box" v-if="typeSelect == 1">
      <div class="type-buttons">
        <van-button
          v-for="(item, index) in check_type_list"
          :key="item.classify_id"
          :class="{ button_select: medal_type_select == index }"
          @click="medalSubTypeClick(index)"
          >{{ item.name }}</van-button
        >
      </div>
      <van-cell-group v-if="medal_type_select == 0">
        <van-cell
          title="本周已打卡"
          :value="count_obj.real_week_count + '次'"
          value-class="cell-value-cus"
        ></van-cell>
      </van-cell-group>
      <van-cell
        title="本学期已打卡"
        :value="count_obj.term_count + '次'"
        value-class="cell-value-cus "
      ></van-cell>
      <van-cell-group v-if="medal_type_select == 0" class="cell_group_margin">
        <van-cell
          title="本学期认定次数"
          :value="count_obj.term_good_count_show + '次'"
          value-class="cell-value-cus"
          :label="
            count_obj.illegal_count > 0
              ? `注：因违规打卡，被扣除${
                  count_obj.term_good_count - count_obj.term_good_count_show
                }次`
              : ''
          "
        ></van-cell>
        <van-cell
          title="奖励折算次数"
          :value="count_obj.match_count + '次'"
          is-link
          value-class="cell-value-cus cell-value-margin-0"
          @click="matchClick"
        ></van-cell>
        <van-cell
          title="合计"
          :value="count_obj.real_total_count + '次'"
          value-class="cell-value-cus cell-value-total-text-color"
          class="cell-value-total"
        ></van-cell>
      </van-cell-group>
      <van-cell-group v-else>
        <!-- <van-cell
          title="本学期还应打卡"
          :value="
            (count_obj.term_num - count_obj.term_count > 0
              ? count_obj.term_num - count_obj.term_count
              : 0) + '次'
          "
          value-class="cell-value-cus"
        ></van-cell> -->
        <van-cell
          title="本月已打卡"
          :value="count_obj.real_month_count + '次'"
          value-class="cell-value-cus"
        ></van-cell>
        <van-cell
          title="本学期已打卡"
          :value="count_obj.term_good_count_show + '次'"
          value-class="cell-value-cus "
        ></van-cell>
      </van-cell-group>
    </div>

    <div class="content-box content-box-margin" v-if="typeSelect == 2">
      <van-list
        finished-text="没有更多了"
        :loading="list_loading"
        :finished="list_load_all"
        :immediate-check="false"
        @load="onLoadListen"
      >
        <van-cell-group>
          <van-cell
            is-link
            center
            v-for="message_item in message_list"
            :key="message_item.id"
            @click="enterMessageInfoDetail(message_item)"
          >
            <template #title>
              <div class="cus-cell-title" v-if="message_item.msg_type == 2">
                <span
                  class="cell-title-cus"
                  :class="{ 'is-read': message_item.isread == 1 }"
                  >审核驳回提醒<span class="cell-title-time">{{
                    message_item.create_time_fmt
                  }}</span></span
                >
                <span class="cell-title-content">您有一条打卡被审核驳回</span>
              </div>
              <div
                class="cus-cell-title"
                v-else-if="message_item.msg_type == 3"
              >
                <span
                  class="cell-title-cus"
                  :class="{ 'is-read': message_item.isread == 1 }"
                  >同步驳回提醒<span class="cell-title-time">{{
                    message_item.create_time_fmt
                  }}</span></span
                >
                <span class="cell-title-content">您有一条打卡被审核驳回</span>
              </div>
              <div class="cus-cell-title" v-else>
                <span
                  class="cell-title-cus"
                  :class="{ 'is-read': message_item.isread == 1 }"
                  >打卡提醒<span class="cell-title-time">{{
                    message_item.create_time_fmt
                  }}</span></span
                >
                <span class="cell-title-content">您收到一条打卡提醒</span>
              </div>
            </template>
          </van-cell>
          <!-- <van-cell is-link center>
              <template #title>
                  <div class="cus-cell-title">
                     <span class="cell-title-cus is-read">打卡提醒<span class="cell-title-time">5分钟前</span></span>
                     <span class="cell-title-content">您收到一条打卡提醒</span>
                  </div>
              </template>
           </van-cell> -->
        </van-cell-group>
      </van-list>
    </div>

    <van-popup v-model:show="show_cell_dialog" closeable>
      <div class="cell-detail-box">
        <div class="table-title">赛事折算详情</div>
        <div class="table-head table-line">
          <div class="table-item">序号</div>
          <div class="table-item">赛事名称</div>
          <div class="table-item">赛事级别</div>
          <div class="table-item">折算次数</div>
        </div>
        <div
          class="table-line"
          v-for="(item, index) in match_list"
          :key="index"
        >
          <div class="table-item">{{ index + 1 }}</div>
          <div class="table-item">{{ item.name }}</div>
          <div class="table-item">{{ item.level }}</div>
          <div class="table-item">{{ item.conv_num }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import req from "@/js/req";
import User from "@/js/user";

const router = useRouter();
const typeSelect = ref(1);
const medal_type_select = ref(0);
const show_cell_dialog = ref(false);
const user_info = ref({});
const check_type_list = ref([]);
const list_loading = ref(false);
const list_load_all = ref(false);
const message_list = ref([]);
const count_obj = ref({
  real_week_count: "",
  term_count_show: "",
  td_count: "",
  match_count: "",
  real_total_count: "",
  real_month_count: "",
  term_good_count_show: "",
});
const match_list = ref([]);

let page = 1;
let limit = 10;

onMounted(() => {
  getUserInfo();
  getCheckTypeList();
  getUserMessage();
});

const getCheckTypeList = async () => {
  let data = await req.get(req.path.get_check_type_list);
  check_type_list.value = data.list;
  getCheckCountList();
};

const getCheckCountList = async () => {
  const p = {
    classify_id: check_type_list.value[medal_type_select.value].classify_id,
    ...User.getUTP(),
  };
  let data = await req.get(req.path.get_check_count, p);
  count_obj.value = data;
  count_obj.value.real_week_count = Math.min(data.week_count, data.week_num);
  // count_obj.value.real_term_count = Math.min(data.term_count, data.term_num);
  count_obj.value.real_total_count =
    count_obj.value.term_good_count_show +
    count_obj.value.match_count +
    count_obj.value.td_count;

  count_obj.value.real_month_count = Math.min(data.month_count, data.month_num);
};

// const resetLoadList = ()=> {
//   page = 1
//   list.value = []
//   list_load_all.value = false
//   list_loading.value =false
//   getUserMessage()

// }
const onLoadListen = () => {
  page += 1;
  getUserMessage();
};
const getUserMessage = async () => {
  const p = {
    page: page,
    limit: limit,
    ...User.getUTP(),
  };
  let data = await req.get(req.path.get_user_message, p);
  message_list.value = [...message_list.value, ...data.list];
  list_loading.value = false;
  if (message_list.value.length >= data.total) {
    list_load_all.value = true;
  }
};

const enterMessageInfoDetail = (item) => {
  router.push({
    path: "/message-detail",
    query: {
      mid: item.msg_record_id,
    },
  });
  if (item.isread == 0) {
    mardMessageisRead(item);
  }
};

const mardMessageisRead = async (item) => {
  const msg_record_ids = JSON.stringify([item.msg_record_id]);
  const p = {
    msg_record_ids: msg_record_ids,
    ...User.getUTP(),
  };

  await req.post(req.path.set_message_read, p);
  item.isread = 1;
  User.getInstance()._message_unread_count.value -= 1;
};

const matchClick = async () => {
  show_cell_dialog.value = true;
  const p = {
    ...User.getUTP(),
    page: 1,
    limit: 1000,
  };
  let data = await req.get(req.path.get_sszs_list, p);
  match_list.value = data.list;
};
const getUserInfo = async () => {
  // let data = await req.get(req.path.get_user_info, User.getUTP());
  user_info.value = User.getUserInfo();
};

const medalTypeClick = (index) => {
  typeSelect.value = index;
};
const medalSubTypeClick = (index) => {
  medal_type_select.value = index;
  getCheckCountList();
};
</script>
<style lang="scss" scoped>
.app-container-box {
  .top-blue-bg {
    height: 192px;
    background: var(--c-blue-linear-gradient-1);
  }
  .user-content-box {
    padding: 0 16px;
    .my-header-box {
      // height: 256px;
      background-size: 100% 100%;
      // background-position-y: 120px;
      // margin-top: 120px;
      border-radius: 16px 16px 0px 0px;
      background: linear-gradient(to bottom, #d4e7ff, #ffffff);
      .user-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: -50px;
        .user-head {
          width: 160px;
          height: 160px;
          border-radius: 100%;
          margin-top: -120px;
          object-fit: cover;
        }
        .user-name {
          font-size: 32px;
          font-weight: bold;
          color: var(--c-text-color-black-8);
        }
        .user-school {
          font-size: 22px;
          color: var(--c-text-color-gray-6);
        }
      }
      .user-tab-box {
        display: flex;
        .user-tab-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: var(--c-text-color-gray-10);
          width: 50%;
          font-size: 32px;
          padding-bottom: 16px;
          img {
            width: 64px;
            height: 64px;
          }
        }
        .select {
          color: var(--van-blue);
          font-weight: bold;
          border-bottom: 8px solid var(--van-blue);
        }
      }
    }
  }
  .content-box {
    padding: 0 16px;
    .type-buttons {
      display: flex;
      justify-content: space-between;
      padding: 32px 0px;
      flex-wrap: wrap;

      .van-button {
        width: 340px;
        margin-top: 10px;
        &:nth-of-type(-2 + n) {
          margin-top: 0px;
        }
      }
    }
  }
  .cus-cell-title {
    display: flex;
    flex-direction: column;
    padding-left: 16px;
    .cell-title-cus {
      font-size: 28px;
      color: var(--c-text-color-black-10);
      font-weight: bold;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 25px;
        left: -20px;
        width: 10px;
        height: 10px;
        background-color: red;
        border-radius: 100%;
      }
      .cell-title-time {
        font-size: 22px;
        color: var(--c-text-color-gray-4);
        font-weight: normal;
        margin-left: 24px;
      }
    }
    .cell-title-content {
      font-size: 32px;
      color: var(--c-text-color-gray-10);
      font-weight: normal;
    }
    .is-read {
      &::before {
        background-color: var(--c-text-color-gray-4);
      }
    }
  }
  .content-box-margin {
    margin-top: 32px;
    margin-bottom: 80px;
  }
}

.cell-detail-box {
  width: 640px;
  height: 780px;
  border: 8px solid var(--van-blue);
  overflow-y: scroll;
  .table-title {
    font-size: 32px;
    font-weight: bold;
    color: var(--c-text-color-black-8);
    text-align: center;
    padding: 24px 0px;
  }
  .table-head {
    font-size: 22px !important;
    font-weight: bold;
    color: var(--van-blue) !important;
    background-color: #e5eefa;
    .table-item {
      text-align: center;
      border-bottom: none !important;
      padding: 16px 0px !important;
    }
  }
  .table-line {
    display: flex;
    font-size: 24px;
    color: var(--c-text-color-black-8);
    .table-item {
      text-align: center;
      padding: 28px 0px;
      border-bottom: 1px solid rgba(131, 133, 136, 0.2);
      &:nth-of-type(1) {
        width: 10%;
      }
      &:nth-of-type(2) {
        width: 40%;
      }
      &:nth-of-type(3) {
        width: 30%;
      }
      &:nth-of-type(4) {
        width: 20%;
      }
    }
  }
}
.cell_group_margin {
  margin-top: 20px;
}
::v-deep .cell-value-cus {
  color: var(--c-text-color-black-8) !important;
  text-align: left;
  margin-right: 34px;
  flex: 0.85;
}
::v-deep .cell-value-total {
  background-color: #f7fafd;
  font-weight: bold;
  color: var(--van-blue);
}
::v-deep .cell-value-total-text-color {
  color: var(--van-blue) !important;
}
::v-deep .cell-value-margin-0 {
  margin-right: 0;
}
</style>
